export default __webpack_public_path__ + "static/media/default-user-profile-image.196d177e.png";